import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { auth } from "../config/firebase";
import { signOut } from "firebase/auth";

export default function Header() {
  const location = useLocation();
  const navigate = useNavigate();
  const [showDropdown, setShowDropdown] = useState(false);

  const logOut = async (e) => {
    e.preventDefault();
    await signOut(auth);
    navigate("/");
  };

  const getPageTitle = () => {
    const path = location.pathname;
    const titles = {
      "/": "Accueil",
      "/users": "Utilisateurs",
      "/add": "Ajouter",
      "/searchs": "Recherches",
      "/matchs": "Matchs",
      "/finds": "Trouvailles",
      "/comments": "Commentaires",
      "/categories": "Catégories",
      "/documents": "Documents",
      "/notifications": "Notifications",
      "/payments": "Paiements",
      "/reviews": "Avis",
      "/reports": "Signalements",
      "/config": "Configuration",
    };
    return titles[path] || "Dashboard";
  };

  return (
    <header className="bg-white border-b border-gray-200 sticky top-0 z-10">
      <div className="px-4 py-2 flex items-center justify-between">
        <h1 className="text-sm font-semibold text-gray-900">
          {getPageTitle()}
        </h1>

        <div className="relative">
          <button
            onClick={() => setShowDropdown(!showDropdown)}
            className="flex items-center gap-2 px-2 py-1 rounded-md hover:bg-gray-50 transition-colors"
          >
            <div className="w-6 h-6 rounded-full bg-gray-900 flex items-center justify-center text-white text-xs font-medium">
              A
            </div>
            <span className="hidden md:inline text-xs text-gray-600">
              {auth.currentUser?.email || "admin"}
            </span>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth={2}
              stroke="currentColor"
              className={`w-3 h-3 text-gray-400 transition-transform ${
                showDropdown ? "rotate-180" : ""
              }`}
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="m19.5 8.25-7.5 7.5-7.5-7.5"
              />
            </svg>
          </button>

          {showDropdown && (
            <>
              <div
                className="fixed inset-0 z-10"
                onClick={() => setShowDropdown(false)}
              ></div>
              <div className="absolute right-0 mt-1 w-48 bg-white rounded-md shadow-lg border border-gray-200 py-1 z-20">
                <div className="px-3 py-2 border-b border-gray-100">
                  <p className="text-xs text-gray-500 truncate">
                    {auth.currentUser?.email || "admin@zzigs.com"}
                  </p>
                </div>
                <button
                  onClick={logOut}
                  className="flex items-center gap-2 w-full px-3 py-2 text-xs text-red-600 hover:bg-red-50 transition-colors"
                >
                  Déconnexion
                </button>
              </div>
            </>
          )}
        </div>
      </div>
    </header>
  );
}
